import {
  mapCubeToDocument,
  CubeDocumentSearchResult,
} from '@dc-shared-web/lib/cubeMappers'
import { AxiosInstance } from 'axios'
import { DocumentSearchResult } from '@dc-shared-web/hooks/api/document/types'

export type GetMainTableQueryParams = {
  currentTable: 'dashboard' | 'archived' | 'shared'
  visitorTimeZone?: string
  sort?: string
  sortDirection?: 'desc' | 'asc'
  currentTeam?: string | null
  currentTeamId?: string
  crunchDate?: string
  solutionType?: string
  offset?: number
  page: 'folder' | 'dashboard' | 'project'
  folderId?: string
  projectId?: string
}

export const fetchMainTableDocuments = async (
  apiClient: AxiosInstance,
  params?: GetMainTableQueryParams
): Promise<{ data: DocumentSearchResult[]; count: number }> => {
  const nonEmptyParams = Object.fromEntries(
    Object.entries(params ?? {}).filter(([, value]) => Boolean(value))
  )
  const { data: axiosData } = await apiClient.get<{
    data: CubeDocumentSearchResult[]
    count: number
  }>(`/ajax/cube/mainTable`, {
    params: nonEmptyParams,
  })
  //The CubeDocumentSearchResult returns an undesirable property structure (e.g., crunch['Crunch.uuid'])
  //that we need to map to a flatter structure (e.g., crunch.uuid) so that it is
  //easier to work with in the frontend.
  return {
    data: axiosData.data.map(mapCubeToDocument),
    count: axiosData.count,
  }
}
